// extracted by mini-css-extract-plugin
export default {"logo":"_83kBf9qFoPcS-zJBkOE4B","headerUtilityActivateFadeIn":"_2JTZMUrbn4fFfiPIB2vOGD","slideUtilityAnimation":"MGsD98Ks-a3TFwbDzdEeV"};